import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import { EntityForm } from '../../widgets/SearchForm';
import { SelectItem } from '../../widgets/SelectItem';
import { CustomTextField } from '../../widgets/CustomTextField';

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    formControl: {
        margin: theme.spacing(1),
    },
    MuiSelectSelectMenu: {
        '& .MuiSelect-selectMenu': { paddingRight: "150px !important" }
    }
}));

export default function HelpdeskRequestSearchForm(props) {
    const [labelWidth, setLabelWidth, tabValue] = React.useState(0);
    const labelRef = React.useRef(null);
    const classes = useStyles();

    React.useEffect(() => {
        if (labelRef.current !== null) {
            setLabelWidth(labelRef.current.offsetWidth);
        }
    }, []);

    return (
        <EntityForm viewId="helpdesk" values={props.data}
            entityLookupController={props.entityLookupController} org="saseta"
            entityLookupId={props.id} useCustomSettings={false} valueChangeHandler={props.valueChangeHandler}>
            {form =>
                <form className={classes.container} >
                    <table cellPadding="2">
                        <tbody>
                            <tr>
                                <td>
                                    <FormControl className={classes.formControl} variant="outlined">
                                        <CustomTextField
                                            id="ReferenceNumber"
                                            label="Reference Number"
                                            className="w-100"
                                            onKeyPress={props.onKeyUp}
                                            InputProps={{
                                                readOnly: false,
                                            }}
                                            form={form}
                                        />
                                    </FormControl>
                                </td>
                                <td>
                                    <FormControl className={classes.formControl} variant="outlined">
                                        <SelectItem
                                            dataUrl="api/sims/HelpDeskRequest/GetLookupList?listId=HelpdeskRequestType"
                                            id="RequestTypeID"
                                            key={tabValue}
                                            label="Request Type"
                                            className={classes.MuiSelectSelectMenu}
                                            allowEmptyValue={true}
                                            form={form}
                                        />
                                    </FormControl>
                                </td>
                                <td>
                                    <FormControl className={classes.formControl} variant="outlined">
                                        <SelectItem
                                            dataUrl="api/sims/HelpDeskRequest/GetLookupList?listId=HelpdeskIssueStatus"
                                            id="StatusID"
                                            key={tabValue}
                                            label="Status"
                                            className={classes.MuiSelectSelectMenu}
                                            allowEmptyValue={true}
                                            form={form}
                                        />
                                    </FormControl>
                                </td>
                                <td>
                                    <FormControl className={classes.formControl} variant="outlined">
                                        <SelectItem
                                            dataUrl="api/sims/HelpDeskRequest/GetLookupList?listId=HelpdeskIssuePriorities"
                                            id="PriorityID"
                                            key={tabValue}
                                            label="Priority"
                                            className={classes.MuiSelectSelectMenu}
                                            allowEmptyValue={true}
                                            form={form}
                                        />
                                    </FormControl>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </form >
            }
        </EntityForm>
    );
}
